// extracted by mini-css-extract-plugin
export default {"address":"style_address__EAi4k","address1":"style_address1__WisRz","address2":"style_address2__wGedp","city":"style_city__ZVcrN","zip":"style_zip__x8V6i"};